import { mapState } from 'vuex';
import timezones, { guessedTimezone } from '@/utils/timezones';
export default {
  name: 'CoreTimezoneSelector',
  inheritAttrs: false,
  props: {
    value: {
      type: String,
      default: null
    },
    mode: {
      type: String,
      required: false,
      default: () => 'edit'
    }
  },
  data() {
    return {
      selectedItem: this.value,
      items: timezones,
      guessedTimezone: guessedTimezone,
      commonAttrs: {}
    };
  },
  computed: {
    ...mapState('app', ['color', 'inpOutlined', 'inpFilled']),
    required() {
      return this.$attrs.required !== undefined && this.$attrs.required !== false;
    },
    clearable() {
      return this.selectedItem !== this.guessedTimezone && this.$attrs.clearable !== undefined && this.$attrs.clearable !== false;
    },
    label() {
      return this.$attrs.label || this.$i18n_t('Common.selectTimezone');
    }
  },
  watch: {
    value(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.selectedItem = newValue;
      }
    }
  },
  mounted() {
    if (!this.value) {
      this.setGuessedTimezone();
    }
  },
  methods: {
    setGuessedTimezone() {
      this.$nextTick(() => {
        this.selectedItem = this.guessedTimezone;
        this.$emit('input', this.selectedItem);
      });
    }
  }
};